import React from 'react'
import { useIntl } from 'hooks'
import { Select, ToggleSwitch } from 'components/Form'

const CollectionFilter = ({ tags, ...formik }) => {
    const { t } = useIntl()

    return (
        <>
            <Select
                name="tag"
                multiple
                label={t('label.tags')}
                options={tags}
                onChange={e => {
                    const v = e.target.value
                    if (v.length > 1 && v.includes('all')) {
                        const index = v.indexOf('all')
                        if (index === 0) {
                            formik.setFieldValue(
                                'tag',
                                e.target.value.filter(t => t !== 'all')
                            )
                        } else {
                            formik.setFieldValue('tag', ['all'])
                        }
                    } else {
                        formik.setFieldValue('tag', e.target.value)
                    }
                    formik.setFieldTouched('tag')
                }}
            />
            <ToggleSwitch label="Shared files only" name="shared" />
        </>
    )
}

export default React.memo(CollectionFilter)
